import { Component, OnInit } from '@angular/core';
import { OperationsService } from '../../../services/operations.service';
import * as moment from 'moment';
import { ToastrService } from 'ngx-toastr';
import { TranslateService } from '@ngx-translate/core';

@Component({
  selector: 'app-receivings',
  templateUrl: './receivings.component.html',
  styleUrls: ['./receivings.component.scss']
})
export class ReceivingsComponent implements OnInit {

  Shipments: any = [];
  ReceivedShipments: any = [];
  PendingShipments: any = [];
  OverageShipments: any = [];
  HAWB: string = '';
  validToReconcile: boolean = false;

  constructor(private operationService: OperationsService, private toaster: ToastrService,private translate: TranslateService) { }

  ngOnInit() { }

  getAndSearchShipments() {
    if (this.Shipments.length == 0) {
      this.operationService.getIncomingShipments({ date: this.getDate() }, (res) => {
        this.Shipments = res;
        if (this.Shipments) {
          if (this.Shipments.length == 0)
            this.toaster.info(`${this.translate.instant('pages.receivingPage.noShipmentFound')}`)
        }
        this.Shipments.forEach((x, index) => {
          x.Status = 'Pending';
          x.Rank = index + 1;
        })
        this.sortShipment();
      },
        (err) => {

        })
    }
    else {
      if (this.Shipments.length == this.calculateNumberOfShipment('Pending')) {
        this.toaster.warning(`${this.translate.instant('pages.receivingPage.atleastOneShipmentScan')}`);
      }
    }
  }

  sortShipment() {
    this.Shipments.sort(function (a, b) { return b.Rank - a.Rank; });
  }

  getMaxShipmentRank() {
    return Math.max.apply(Math, this.Shipments.map(function (o) { return o.Rank; }));
  }

  getDate() {
    let date = new Date();
    if (date)
      return moment(date).format('YYYY-MM-DD');
    return '-';
  }

  calculateNumberOfShipment(shipmentStatus) {
    return this.Shipments.filter(x => x.Status == shipmentStatus).length;
  }

  getShipmentStatusClass(shipmentStatus) {
    if (shipmentStatus == 'Received')
      return 'btn-intact';
    else if (shipmentStatus == 'Pending')
      return 'btn-shortage';
    else if (shipmentStatus == 'Overage')
      return 'btn-overage';
    else
      return 'btn-default';
  }

  getShipmentStatusCode(shipmentStatus) {
    if (shipmentStatus == 'Received')
      return 1;
    else if (shipmentStatus == 'Overage')
      return 2;
    else if (shipmentStatus == 'Pending')
      return 3;
    else
      return 0;
  }

  reconcileReceivedShipments() {
    var Shipments = [];
    this.Shipments.forEach((x) => {
      Shipments.push({
        "AWB": x.AWB,
        "Status": this.getShipmentStatusCode(x.Status)
      })
    });
    this.operationService.reconcileShipments({ Shipments },
      (res) => {
        this.Shipments = [];
        this.toaster.success(`${this.translate.instant('pages.receivingPage.successMsg')}`);
        this.validToReconcile = false;
      }, (err) => {
        this.toaster.error(`${this.translate.instant('pages.receivingPage.errorShipmentMsg')}`);
      })
  }

  onKeydown(event) {
    if (this.Shipments.length > 0) {
      var currentShipment = this.Shipments.filter(x => x.AWB == this.HAWB)[0];
      if (currentShipment) {
        currentShipment.Status = 'Received';
        currentShipment.Rank = this.getMaxShipmentRank() + 1;
        this.sortShipment();
        this.HAWB = '';
        this.validToReconcile = true;
      }
      else if (this.HAWB != "" && this.Shipments.length > 0) {
        var NewAWB = this.HAWB;
        this.Shipments.push({
          AWB: NewAWB,
          Status: 'Overage',
          Pieces: 1,
          BranchId: 0,
          RunSheetDate: this.getDate(),
          Rank: this.getMaxShipmentRank() + 1
        })
        this.sortShipment();
        this.HAWB = '';
        this.validToReconcile = true;
      }
    }
    else {
      this.toaster.warning(`${this.translate.instant('pages.receivingPage.receiveShipmentThenScan')}`);
    }
  }

}
